import { Main } from './components';

const Clients = () => <Main />;

export default Clients;

